module.exports = __webpack_public_path__ + "static/img/left.0280b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left.png
// module id = 936
// module chunks = 173